import React, { useState, useEffect } from "react";
import { AlertTriangle, Package } from "lucide-react";
import { Link } from "react-router-dom";
import api from "../../../config/api";

const InventoryAlerts = () => {
  const [inventoryData, setInventoryData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchInventoryData();
  }, []);

  const fetchInventoryData = async () => {
    try {
      const response = await api.get("/admin/dashboard/inventory");
      setInventoryData(response.data.data);
    } catch (error) {
      console.error("Error fetching inventory data:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="bg-white shadow rounded-lg p-6">
        <div className="flex justify-center items-center h-32">
          <div className="w-6 h-6 border-4 border-primary-600 border-t-transparent rounded-full animate-spin"></div>
        </div>
      </div>
    );
  }

  if (!inventoryData) return null;

  const hasAlerts =
    inventoryData.lowStockCount > 0 || inventoryData.outOfStockCount > 0;

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          <div className="w-10 h-10 bg-orange-500 rounded-md flex items-center justify-center">
            <Package className="w-6 h-6 text-white" />
          </div>
          <div className="ml-4">
            <h3 className="text-sm font-medium text-gray-500">
              Inventory Alerts
            </h3>
            <p className="text-2xl font-semibold text-gray-900">
              {inventoryData.lowStockCount + inventoryData.outOfStockCount}
            </p>
          </div>
        </div>
        {hasAlerts && (
          <AlertTriangle className="w-6 h-6 text-orange-500" />
        )}
      </div>

      <div className="space-y-4">
        <div>
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-medium text-gray-700">
              Low Stock ({inventoryData.lowStockCount})
            </span>
            <span className="text-xs text-gray-500">
              Total Value: ₹
              {parseFloat(
                inventoryData.summary?.totalInventoryValue || 0
              ).toFixed(2)}
            </span>
          </div>
          {inventoryData.lowStockProducts &&
          inventoryData.lowStockProducts.length > 0 ? (
            <div className="space-y-2 max-h-32 overflow-y-auto">
              {inventoryData.lowStockProducts.slice(0, 5).map((product) => (
                <div
                  key={product.id}
                  className="flex items-center justify-between p-2 bg-orange-50 rounded-md"
                >
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-gray-900 truncate">
                      {product.productName}
                    </p>
                    <p className="text-xs text-gray-500">
                      SKU: {product.sku || "N/A"}
                    </p>
                  </div>
                  <div className="ml-2">
                    <span className="text-sm font-semibold text-orange-600">
                      {product.stock} left
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-sm text-gray-500">No low stock items</p>
          )}
        </div>

        <div>
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-medium text-gray-700">
              Out of Stock ({inventoryData.outOfStockCount})
            </span>
          </div>
          {inventoryData.outOfStockProducts &&
          inventoryData.outOfStockProducts.length > 0 ? (
            <div className="space-y-2 max-h-32 overflow-y-auto">
              {inventoryData.outOfStockProducts.slice(0, 5).map((product) => (
                <div
                  key={product.id}
                  className="flex items-center justify-between p-2 bg-red-50 rounded-md"
                >
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-gray-900 truncate">
                      {product.productName}
                    </p>
                    <p className="text-xs text-gray-500">
                      SKU: {product.sku || "N/A"}
                    </p>
                  </div>
                  <div className="ml-2">
                    <span className="text-sm font-semibold text-red-600">
                      Out of Stock
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-sm text-gray-500">No out of stock items</p>
          )}
        </div>

        {hasAlerts && (
          <Link
            to="/admin/products"
            className="block text-center text-sm text-primary-600 hover:text-primary-700 font-medium mt-4"
          >
            View All Products →
          </Link>
        )}
      </div>
    </div>
  );
};

export default InventoryAlerts;


